export default "__VITE_ASSET__DdueurQW__"